// Handles all routing and navigation for the account dashboard

// Main route change function
const routeChange = (page) => {
  event.preventDefault();

  // Remove active-link class from all links
  const activeItems = document.querySelectorAll('.dashboard-header__links .active-link');
  if (activeItems) {
    activeItems.forEach(el => {
      el.classList.remove('active-link');
    });
  }

  const newUrl = `${window.location.pathname}?page=${page}`;
  history.pushState(null, '', newUrl);

  // Add active-link class to the clicked link
  const newActiveItems = document.querySelectorAll(`.dashboard-header__links li[data-page="${page}"]`);
  if (newActiveItems) {
    newActiveItems.forEach(el => {
      el.classList.add('active-link');
    });
  }

  // Updates the mobile navigation title element to reflect the page the user is on
  const mobileActiveItem = document.querySelector(".account-header__container .account__accordion-container .accordion__toggle .text-with-icon")
  const newMobileActiveItem = document.querySelector(`[data-page="${page}"]`).innerHTML;
  if (mobileActiveItem && newMobileActiveItem) {
    mobileActiveItem.innerHTML = newMobileActiveItem.toUpperCase()
  }

  // Hide all active sections
  const sectionsToHide = document.querySelectorAll('.active');
  if (sectionsToHide) {
    sectionsToHide.forEach(el => {
      el.classList.remove('active');
      el.classList.add('hidden');
    });
  }

  // Show the specific section
  const sectionToShow = document.querySelector(`#${page}`);
  if (sectionToShow) {
    sectionToShow.classList.add('active');
    sectionToShow.classList.remove('hidden');
  }
};

// Add event listeners to 3 custom account pages
const accountTriggers = document.querySelectorAll('.account-details__trigger');
if (accountTriggers) {
  accountTriggers.forEach(trigger => {
    trigger.addEventListener('click', function () {
      routeChange('account-details');
      document.querySelector(".account__accordion-container summary").click();
    });
  });
}

const orderTriggers = document.querySelectorAll('.order-details__trigger');
if (orderTriggers) {
  orderTriggers.forEach(trigger => {
    trigger.addEventListener('click', function () {
      routeChange('order-details');
      document.querySelector(".account__accordion-container summary").click();
    });
  });
}

const rewardsTriggers = document.querySelectorAll('.rewards-details__trigger');
if (rewardsTriggers) {
  rewardsTriggers.forEach(trigger => {
    trigger.addEventListener('click', function () {
      routeChange('rewards-details');
      document.querySelector(".account__accordion-container summary").click();
    });
  });
}

// Listen for the load event to check the URL and trigger routeChange if necessary
window.addEventListener('load', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const page = urlParams.get('page');

  const routesToCheck = ['account-details', 'order-details', 'rewards-details'];

  if (page && routesToCheck.includes(page)) {
    routeChange(page);
  } else {
    const dashboard = document.querySelector(`.dashboard-parent__container `);
    if (dashboard) {
      dashboard.classList.add('active');
      dashboard.classList.remove('hidden');
    }
  }
});